import React, {useEffect, useRef, useState} from 'react';
import {Box, Sheet, Stack} from '@mui/joy';
import GraphicWork from "../components/GraphicWork";
import CoverManjePeyim from "../assets/project/cover-manje-pey-m.jpg";
import CoverMounMoutMounMoun from "../assets/project/Cover-moun-moute-moun-moun.jpg";
import CoverOuPanikem from "../assets/project/cover-ou-panike-m.jpg";
import FlyerCampCFSFLU from "../assets/project/Flyer Camp CFSFLU 2023 - 4.jpg";
import FlyerSeminaireGraphicDesign from "../assets/project/flyer-seminaire-graphic-design-08-07-2023.jpg";
import FlyerMatch3emPlace from "../assets/project/Matche 3e place.jpg";
import LogoJubyStar from "../assets/project/Logo Jubystar_1.gif";
import FlyerLancementLuneauCup from "../assets/project/Flyer-lancement-luneau-cup.jpg";
import FlyerTGMatchFinal from "../assets/project/TG FINAL MATCH FINAL.jpg";
import MockupInextricable from "../assets/project/mockup-website-inextricable.jpg";
import MockupPortfoliFumavipeman from "../assets/project/mockup-portfolio-fumavipeman.jpg";
import MockupFumalocker from "../assets/project/mockup-app-fumalocker.jpg";
import {ServiceModel} from "../model/service";
import {ProjectModel} from "../model/project";
import {ProjectRepository} from "../repository/ProjectRepository";
import Typography from "@mui/joy/Typography";
import LoadingPage from "./Loading";
import TimeOutPage from "./TimeOut";
import Footer from "../components/Footer";

function WorksPage() {
    const repo = new ProjectRepository()
    const [project, setProject] = useState<Array<ProjectModel>>([]);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        repo.getAllProject().then(value => {
                if (value.length > 0) {
                    let projectSorted = value.sort((a, b) =>  b.quality - a.quality)
                    projectSorted = projectSorted.sort((a, b) => b.category.indexOf('Development') - a.category.indexOf('Development'))
                    setProject(projectSorted)
                }
            }
        ).catch(reason => setError(true));
    }, [])
    return (
        <Box>
            <Box paddingTop={2} paddingX={{xs: 2, md: 6}} sx={{bgcolor: 'background.surface'}}>
                {!(project.length > 0) && (
                    <LoadingPage/>
                )}
                {(project.length > 0 && error) && (
                    <TimeOutPage/>
                )}
                {(project.length > 0 && !error) && (
                    <Sheet sx={{
                        minHeight: '100vh',
                        paddingX: 2,
                        paddingY: 2,
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Stack spacing={2} direction={{xs: 'column', md: 'column'}}>
                            <Typography level="h4" fontWeight='bolder'>
                                Explore My Popular
                                <Typography color='primary'> Projects</Typography>
                            </Typography>
                            <Stack spacing={2} direction='column'>
                                {project.map(value => (
                                    <GraphicWork project={value}/>
                                ))}
                            </Stack>
                        </Stack>
                    </Sheet>
                )}
            </Box>
        </Box>
    );
}

export default WorksPage;
